// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A56p","left":"styles_left__1-Xrl"};